module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_gaku-a3c9953ae87e830c11e4d124c2fed578.png";